import { Component, Vue, Prop } from 'vue-property-decorator'
import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import { UIService } from '@core/services/UIService'
import { PriorityItem } from '@master/model/kyc-form/need-analysis/PrioritiesNeeds2'
import ExistingPortfolio from '@master/model/kyc-form/existing-plans/ExistingPortfolio'
import KYCClient from '@master/model/kyc-form/KYCClient'
import { IPrioritiesStructure } from '@master/model/kyc-form/need-analysis/IPrioritiesStructure'
import { IRiskRatingService } from '@master/services/IRiskRatingService'
import { PaymentModeOptions } from '@master/model/options/PaymentModeOptions'
import { FrequencyOptions } from '@master/model/options/FrequencyOptions'
import { CompanyDetailsMetaList } from '@core/pages/companyDetails/model/CompanyDetailsMetaList'
import { ProductMeta } from '@master/model/common/ProductMeta'
import { ProductList } from '@core/pages/adminProductList/model/ProductList'
import { IProjectInfo } from '@master/config/IProjectInfo'
import { options } from '@master/model/options/Options'

@Component
export default class TheRcmdProductMixin extends Vue {
  @Prop() protected ownerOptions: { name: string; value: number }[]
  @Prop() protected newBasicProduct: BasicProduct
  @Prop() protected nameList: options[]
  @Prop() protected selectedPriorities: PriorityItem<KYCClient, ExistingPortfolio>[]
  @Prop() protected cdMetaList: CompanyDetailsMetaList
  @Prop() protected productList: ProductList
  @Prop({ default: () => [] }) protected currentRcmdList: BasicProduct[]
  @Prop({ default: false }) saveOnClick

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private ThePrioritiesNeeds: IPrioritiesStructure<KYCClient>

  @inject()
  protected riskRatingService: IRiskRatingService

  @inject()
  protected projectInfo: IProjectInfo

  protected mainBasicProduct: BasicProduct = null

  protected needsOptions = []

  protected uiService: UIService
  get paymentModeOptions () {
    return [{ label: '', value: '' }, ...PaymentModeOptions]
  }

  get frequencyOptions () {
    return [{ label: undefined, value: undefined }].concat(FrequencyOptions.map(freq => {
      return freq
    }))
  }

  get priorityOptionsMap () {
    return this.selectedPriorities.map(prior => {
      return {
        label: prior.name,
        value: prior.id
      }
    })
  }

  get riskRatingOption () {
    const riskRatingMap = this.riskRatingService.riskRatingMap()
    return Object.keys(riskRatingMap).map(key => {
      return {
        value: key,
        label: riskRatingMap[key]
      }
    })
  }

  get currencySymbol () {
    const symbol = this.projectInfo.currencyToLabel ?? '$'
    return `(${symbol})`
  }

  getPriorityById (id: string) {
    return this.selectedPriorities.find(priority => priority.id === id)
  }

  get needsOptionsMap () {
    return this.needsOptions.map(need => {
      return { label: need, value: need }
    })
  }

  updateCustomProduct (productFund, newVal) {
    if (!newVal) return
    productFund.oid = newVal

    // update the need: to empty the need if the selected product didnt cover the preset one
    if (!productFund.need ||
      (productFund.need && !productFund.productNeedsCovered.includes(productFund.need))) {
      productFund.need = productFund.productNeedsCovered[0] ?? ''
    }
  }

  updateSelectedProduct (selectedOid, frontEndProductList, model, fromUI = true) {
    if (!selectedOid) return

    const selected = frontEndProductList.find(prod => prod.oid === selectedOid)

    if (!selected && fromUI) {
      return this.uiService.alert.show({
        type: 'error',
        message: 'Invalid product selected'
      })
    } else if (!selected && !fromUI) {
      return
    }

    const productMeta = new ProductMeta()

    Object.assign(productMeta, {
      ...selected,
      needsCovered: JSON.parse(selected.needsCovered)
    })

    model.setProduct(productMeta)

    // update the need: to empty the need if the selected product didnt cover the preset one
    if (!model.need ||
    (model.need && !model.productNeedsCovered.includes(model.need))) {
      model.need = model.productNeedsCovered[0] ?? ''
    }
  }

  clearProductOidOnChange (model) {
    model.resetProduct()
  }

  handlePriorityOnChange (model, newVal) {
    if (!model.need) {
      model.need = this.getPriorityById(newVal).needs
    }
  }

  handleNeedsOnChange (model, newVal) {
    if (!model.productNeedsCovered.includes(newVal)) {
      // if preselected product's needs cover didnt include this needs, then reset
      this.clearProductOidOnChange(model)
    }
  }

  getProductNotFilledMessage (product, mustFilledKey: {key: string; display: string}[]) {
    return mustFilledKey.map(mainAccountKey => {
      const value = product[mainAccountKey.key]
      if (typeof value === 'undefined' || value === '' || value === null) {
        return mainAccountKey.display
      }
    }).filter(data => data)
  }

  mounted () {
    this.uiService = this.sharedVariable.uiService
    this.needsOptions = this.ThePrioritiesNeeds.getNeeds()
  }

  created () {
    this.mainBasicProduct = new BasicProduct(this.riskRatingService)
    Object.assign(this.mainBasicProduct, this.newBasicProduct)
  }
}
